export default __webpack_public_path__ + "./ico-dependent.df9e387048bb6ca69e10319878584447.png";